import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../components/Navigation/Navigation';
import flagImage from '../../../shared/assets/images/flag.png';
import './AboutPage.css';

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="about-page">
      <Navigation />
      <div className="page-content">
        <div className="container">
          <div className="about-content">
            <div className="about-hero">
              <h1>About Bounce Loyalty</h1>
              <p className="about-subtitle">Proudly Canadian. Passionately Supporting Small Business.</p>
            </div>
            
            <div className="about-text">
              <h2>Proudly Canadian</h2>
              <p>
              Bounce Loyalty is proudly owned and operated in Canada by Canadians. We understand the unique challenges facing small businesses across the country, and we’re committed to helping local owners strengthen customer relationships while growing the communities we all share.
              </p>
              
              <h2>We Love Small Businesses</h2>
              <p>
                Small businesses are the heart and soul of what makes our neighbourhoods great. They're the local coffee shops 
                where neighbors meet, the family restaurants that serve comfort food, and the boutiques 
                that add character to our streets. Wether your in Cabbagetown in Toronto or Kelowna, BC, we believe small business deserves access 
                to the same powerful tools that big chains use.
              </p>
              
              <h2>Our Mission</h2>
              <p>
                We think that most loyalty programs out there suck! We're on a mission to make customer loyalty simple, affordable, and accessible for every 
                small business owner. No complicated apps to download, no punch cards to lose, no expensive 
                systems to learn. Just tap, earn, and redeem.
              </p>
              
              <h2>Why We're Different</h2>
              <p>
                Unlike big tech companies (not gonna name any names) that treat small businesses as just another number, we genuinely care 
                about your success. We're here to support Canadian entrepreneurs with technology that's designed 
                specifically for small businesses, and were always looking to improve our product for you.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="page-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>Bounce Loyalty</h3>
              <p>The world's easiest loyalty program.</p>
            </div>
            <div className="footer-section">
              <h4>Product</h4>
              <ul>
                <li><Link to="/#features">Features</Link></li>
                <li><Link to="/#how-it-works">How it Works</Link></li>
                <li><Link to="/pricing">Pricing</Link></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Company</h4>
              <ul>
                <li><a href="mailto:jakob.solstrozberg@torontomu.ca">Contact</a></li>
                <li><Link to="/about">About Us</Link></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Get Started</h4>
              <ul>
                <li><Link to="/businesssignup">Sign Up</Link></li>
                <li><Link to="/businesssignin">Sign In</Link></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="proudly-canadian">
              <img src={flagImage} alt="Canadian Flag" className="canadian-flag" />
              <span>Proudly Canadian</span>
            </div>
            <p>&copy; 2025 Bounce Loyalty. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AboutPage;
